import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom'; 
import { useAuth } from '../utils/AuthContext/AuthContext'; 
import { useMediaQuery } from 'react-responsive';
import LogoutButton from './LogoutButton';
import UserMenu from './UserDropdown/UserDisplay';
import MenuSVG from '../assets/Menu';
import ShishitoSVG from '../assets/Logo/ShishitoLogo';
import ShishitoMarkSVG from '../assets/Logo/ShishitoMark';
import SettingsSVG from '../assets/Settings';
import HomeIconSVG from '../assets/HomeIcon'; 
import FormsSVG from '../assets/Forms'; 
import PeopleSVG from '../assets/PeopleNav'; 
import MessagesSVG from '../assets/Messages'; 
import FeedbackSVG from '../assets/Feedback'; 
import LoginSVG from '../assets/Login';
import SettingsModal from './SettingsModal';
import './UserDropdown/UserDisplay.css';

export default function NavSide() {
    const location = useLocation();
    const { isAuthenticated, logout, user } = useAuth(); 
    const [isOpen, setIsOpen] = useState(false);
    const [isSettingsModalOpen, setIsSettingsModalOpen] = useState(false);
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const menuRef = useRef();

    const isSelected = (path) => {
        if (path === '/') {
            return location.pathname === '/';
        }
        return location.pathname.startsWith(path);
    };

    useEffect(() => {
        const handleClick = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClick);
        return () => {
            document.removeEventListener("mousedown", handleClick);
        };
    }, []);

    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };

    const handleMenuClick = (callback) => {
        setIsOpen(false);
        if (callback) callback();
    };

    const renderMobileMenu = () => {
        if (!isMobile) return null;

        return (
            <div className="fixed top-0 left-0 w-screen h-[55px] bg-white border-b border-slate-300 flex justify-between items-center px-2 z-50">
                <div className='inline-flex items-center relative z-50'>
                    <div ref={menuRef} className="relative">
                        <button onClick={toggleDropdown} className="z-50">
                            <MenuSVG />
                        </button>
                        {isOpen && (
                            <div className="modal-dropdown absolute top-[35px] left-0 w-[250px] bg-white shadow-md rounded-md p-2 z-[1000]">
                                {isAuthenticated ? (
                                    <ul className='list-none p-0 m-0 w-full'>
                                        <li className='p-2 cursor-pointer font-light hover:bg-gray-200 w-full'>
                                            <Link to="/" className='block text-shi-green' onClick={() => handleMenuClick()}>Home</Link>
                                        </li>
                                        <li className='p-2 cursor-pointer font-light hover:bg-gray-200 w-full'>
                                            <Link to="/forms" className='block text-shi-green' onClick={() => handleMenuClick()}>Forms</Link>
                                        </li>
                                        <li className='p-2 cursor-pointer font-light hover:bg-gray-200 w-full'>
                                            <Link to="/professionals" className='block text-shi-green' onClick={() => handleMenuClick()}>Professionals</Link>
                                        </li>
                                        <li className='p-2 cursor-pointer font-light hover:bg-gray-200 w-full'>
                                            <Link to="/messages" className='block text-shi-green' onClick={() => handleMenuClick()}>Messages</Link>
                                        </li>
                                        <li className='p-2 cursor-pointer font-light hover:bg-gray-200 w-full'>
                                            <Link to="/feedback" className='block text-shi-green' onClick={() => handleMenuClick()}>Feedback</Link>
                                        </li>
                                        <li className='p-2 cursor-pointer font-light hover:bg-gray-200 w-full'>
                                            <button onClick={() => handleMenuClick(() => setIsSettingsModalOpen(true))} className='text-shi-green'>Settings</button>
                                        </li>
                                    </ul>
                                ) : (
                                    <ul className='list-none p-0 m-0 w-full'>
                                        <li className='p-2 cursor-pointer font-light hover:bg-gray-200 w-full'>
                                            <Link to="/" className='block text-shi-green' onClick={() => handleMenuClick()}>Home</Link>
                                        </li>
                                        <li className='p-2 cursor-pointer font-light hover:bg-gray-200 w-full'>
                                            <Link to="/privacy" className='block text-shi-green' onClick={() => handleMenuClick()}>Privacy Policy</Link>
                                        </li>
                                        <li className='p-2 cursor-pointer font-light hover:bg-gray-200 w-full'>
                                            <Link to="/termsofuse" className='block text-shi-green' onClick={() => handleMenuClick()}>Terms of Use</Link>
                                        </li>
                                        <li className='p-2 cursor-pointer font-light hover:bg-gray-200 w-full'>
                                            <Link to="/login" className='block text-shi-green' onClick={() => handleMenuClick()}>Sign In</Link>
                                        </li>
                                    </ul>
                                )}
                            </div>
                        )}
                    </div>
                    <Link to="/" className="ml-4">
                        <ShishitoMarkSVG width={35} height={35} />
                    </Link>
                </div>
                <div className="ml-auto">
                    {isAuthenticated ? (
                        <div className="mx-5">
                            {/* <UserMenu user={user}/> */}
                        </div>
                    ) : (
                        <div className='inline-flex justify-end items-center align-middle'>
                            <div className="mx-5">
                                <Link 
                                    to="/login"
                                    className="lg:text-[16px] md:text-[14px] w-[40px] px-2 py-[5px] text-shi-green rounded-md text-sm md:text-[16px] font-[Inter] hover:bg-white hover:text-shi-green"
                                >
                                    Sign In
                                </Link>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    return (
        <>
            {isMobile ? (
                <>
                    {renderMobileMenu()}
                    <div className="mt-[55px]" /> {/* Changed to margin-top to prevent content overlap */}
                </>
            ) : (
                <div className="w-64 h-screen bg-neutral-100 flex flex-col sticky top-0">
                    <div className="w-24 pl-3 flex flex-col justify-start items-center">
                        <ShishitoSVG className="w-28 h-5" />
                    </div>
                    <div className="flex-1 flex flex-col justify-between pt-6 pb-10 pl-4">
                        {isAuthenticated ? (
                            <>
                                <div className="flex flex-col justify-center items-start gap-3 px-3">
                                    <Link to="/" className="w-full">
                                        <div className={`h-full w-full p-[8px] rounded-xl inline-flex items-center gap-[10px] ${isSelected('/') ? 'bg-shi-light-mysterious-green' : 'hover:bg-shi-green/10'}`}>
                                            <div className="flex h-full justify-center items-center">
                                                <HomeIconSVG width={18} height={18} fill={isSelected('/') ? "#30012A" : "#044225"} />
                                            </div>
                                            <div className={`w-full text-[13px] font-['Inter'] ${isSelected('/') ? 'text-shi-deep-purple' : 'text-shi-green'}`}>HOME</div>
                                        </div>
                                    </Link>
                                    <Link to="/forms" className="w-full">
                                        <div className={`h-full w-full p-[8px] rounded-xl inline-flex items-center gap-[10px] ${isSelected('/forms') ? 'bg-shi-light-mysterious-green' : 'hover:bg-shi-green/10'}`}>
                                            <div className="flex h-full justify-center items-center">
                                                <FormsSVG width={18} height={18} fill={isSelected('/forms') ? "#30012A" : "#044225"} />
                                            </div>
                                            <div className={`w-full text-[13px] font-['Inter'] ${isSelected('/forms') ? 'text-shi-deep-purple' : 'text-shi-green'}`}>FORMS</div>
                                        </div>
                                    </Link>
                                    <Link to="/professionals" className="w-full">
                                        <div className={`h-full w-full p-[8px] rounded-xl inline-flex items-center gap-[10px] ${isSelected('/professionals') ? 'bg-shi-light-mysterious-green' : 'hover:bg-shi-green/10'}`}>
                                            <div className="flex h-full justify-center items-center">
                                                <PeopleSVG width={18} height={18} fill={isSelected('/professionals') ? "#30012A" : "#044225"} />
                                            </div>
                                            <div className={`w-full text-[13px] font-['Inter'] ${isSelected('/professionals') ? 'text-shi-deep-purple' : 'text-shi-green'}`}>PROFESSIONALS</div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="flex flex-col justify-center items-start gap-3 px-3">
                                    <Link to="/messages" className="w-full">
                                        <div className={`h-full w-full p-[8px] rounded-xl inline-flex items-center gap-[10px] ${isSelected('/messages') ? 'bg-shi-light-mysterious-green' : 'hover:bg-shi-green/10'}`}>
                                            <div className="flex h-full justify-center items-center">
                                                <MessagesSVG width={18} height={18} fill={isSelected('/messages') ? "#30012A" : "#044225"} />
                                            </div>
                                            <div className={`w-full text-[13px] font-['Inter'] ${isSelected('/messages') ? 'text-shi-deep-purple' : 'text-shi-green'}`}>MESSAGES</div>
                                        </div>
                                    </Link>
                                    <Link to="/feedback" className="w-full">
                                        <div className={`h-full w-full p-[8px] rounded-xl inline-flex items-center gap-[10px] ${isSelected('/feedback') ? 'bg-shi-light-mysterious-green' : 'hover:bg-shi-green/10'}`}>
                                            <div className="flex h-full justify-center items-center">
                                                <FeedbackSVG width={18} height={18} fill={isSelected('/feedback') ? "#30012A" : "#044225"} />
                                            </div>
                                            <div className={`w-full text-[13px] font-['Inter'] ${isSelected('/feedback') ? 'text-shi-deep-purple' : 'text-shi-green'}`}>FEEDBACK</div>
                                        </div>
                                    </Link>
                                    <button onClick={() => setIsSettingsModalOpen(true)} className="w-full">
                                        <div className="h-full w-full p-[8px] rounded-xl inline-flex items-center gap-[10px] hover:bg-shi-green/10">
                                            <div className="flex h-full justify-center items-center">
                                                <SettingsSVG width={18} height={18} fill="#044225" />
                                            </div>
                                            <div className="text-[13px] font-['Inter'] text-shi-green">SETTINGS</div>
                                        </div>
                                    </button>
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="flex flex-col justify-center items-start gap-3 px-3">
                                    <Link to="/" className="w-full">
                                        <div className={`h-full w-full p-[8px] rounded-xl inline-flex items-center gap-[10px] ${isSelected('/') ? 'bg-shi-light-mysterious-green' : 'hover:bg-shi-green/10'}`}>
                                            <div className="flex h-full justify-center items-center">
                                                <HomeIconSVG width={18} height={18} fill={isSelected('/') ? "#30012A" : "#044225"} />
                                            </div>
                                            <div className={`w-full text-[13px] font-['Inter'] ${isSelected('/') ? 'text-shi-deep-purple' : 'text-shi-green'}`}>HOME</div>
                                        </div>
                                    </Link>
                                </div>
                                <div className="flex flex-col justify-center items-start gap-3 px-3">
                                    <Link to="/privacy" className="w-full">
                                        <div className={`h-full w-full p-[8px] rounded-xl inline-flex items-center gap-[10px] ${isSelected('/privacy') ? 'bg-shi-light-mysterious-green' : 'hover:bg-shi-green/10'}`}>
                                            <div className="flex h-full justify-center items-center">
                                                <FormsSVG width={18} height={18} fill={isSelected('/privacy') ? "#30012A" : "#044225"} />
                                            </div>
                                            <div className={`w-full text-[13px] font-['Inter'] ${isSelected('/privacy') ? 'text-shi-deep-purple' : 'text-shi-green'}`}>PRIVACY POLICY</div>
                                        </div>
                                    </Link>
                                    <Link to="/termsofuse" className="w-full">
                                        <div className={`h-full w-full p-[8px] rounded-xl inline-flex items-center gap-[10px] ${isSelected('/termsofuse') ? 'bg-shi-light-mysterious-green' : 'hover:bg-shi-green/10'}`}>
                                            <div className="flex h-full justify-center items-center">
                                                <FormsSVG width={18} height={18} fill={isSelected('/termsofuse') ? "#30012A" : "#044225"} />
                                            </div>
                                            <div className={`w-full text-[13px] font-['Inter'] ${isSelected('/termsofuse') ? 'text-shi-deep-purple' : 'text-shi-green'}`}>TERMS OF USE</div>
                                        </div>
                                    </Link>
                                    <Link to="/login" className="w-full">
                                        <div className={`h-full w-full p-[8px] rounded-xl inline-flex items-center gap-[10px] ${isSelected('/login') ? 'bg-shi-light-mysterious-green' : 'hover:bg-shi-green/10'}`}>
                                            <div className="flex h-full justify-center items-center">
                                                <LoginSVG width={18} height={18} fill={isSelected('/login') ? "#30012A" : "#044225"} />
                                            </div>
                                            <div className={`w-full text-[13px] font-['Inter'] ${isSelected('/login') ? 'text-shi-deep-purple' : 'text-shi-green'}`}>SIGN IN</div>
                                        </div>
                                    </Link>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            )}
            <SettingsModal 
                isOpen={isSettingsModalOpen} 
                onClose={() => setIsSettingsModalOpen(false)} 
                user={user}
            />
        </>
    );
}
